<script>
export default {
  props: {
    value: {
      type: [
        Number, String,
      ],
      required: false,
      default: () => ({
        //
      }),
    },
  },

  mounted () {
    this.$http.get(`/automation/template`)
      .then(({ data }) => {
        this.templates = data;
      });
  },

  data: () => ({
    query: '',
    templates: [
      //
    ],
  }),

  computed: {
    filtered () {
      return this.templates.filter(({ title }) => title.toLowerCase().includes(this.query.toLowerCase()));
    },
  },
};
</script>

<template>
  <div
    class="bdk-w-full bdk-h-full bdk-preflight"
  >
    <div
      class="form-group"
    >
      <input
        type="text"
        required=""
        autofocus=""
        id="autofocus"
        v-model="query"
        class="form-control"
        :placeholder="__('Digite para buscar um Template')"
      >
    </div>

    <div
      class="bdk-flex bdk-flex-col bdk-mt-5 bdk-pt-5 bdk-border-t bdk-border-gray-200"
    >
      <AutomationListItem
        v-bind="template"
        :key="`template-${index}`"
        :active="value === template.id"
        v-for="(template, index) in filtered"
        @selected="$emit('input', template.id)"
      />
    </div>
  </div>
</template>
